const MACEIO_VIEWBOX = "-35.80,-9.50,-35.69,-9.71";
window.MACEIO_VIEWBOX = MACEIO_VIEWBOX;

function usePlaceSuggestions(query, active) {
  const [suggestions, setSuggestions] = React.useState([]);
  const debounceRef = React.useRef(null);
  const abortRef = React.useRef(null);

  React.useEffect(() => {
    clearTimeout(debounceRef.current);
    if (!active || !query || query.trim().length < 3) {
      setSuggestions([]);
      return;
    }
    debounceRef.current = setTimeout(() => {
      if (abortRef.current) abortRef.current.abort();
      const controller = new AbortController();
      abortRef.current = controller;
      const url = `https://nominatim.openstreetmap.org/search?format=json&limit=15&q=${encodeURIComponent(query + ", Maceió, Brasil")}&viewbox=${MACEIO_VIEWBOX}&bounded=1`;
      fetch(url, { signal: controller.signal })
        .then((r) => r.json())
        .then((data) => {
          const seen = new Set();
          const out = [];
          for (const d of data || []) {
            const name = d.name || (d.display_name || "").split(",")[0];
            const lat = parseFloat(d.lat), lng = parseFloat(d.lon);
            if (!name || isNaN(lat) || isNaN(lng)) continue;
            const dedupeKey = `${Math.round(lat * 2000)}:${Math.round(lng * 2000)}`;
            if (seen.has(dedupeKey)) continue;
            seen.add(dedupeKey);
            out.push({
              name,
              detail: (d.display_name || "").split(",").slice(1, 3).join(",").trim(),
              lat,
              lng,
            });
            if (out.length >= 8) break;
          }
          setSuggestions(out);
        })
        .catch(() => {});
    }, 450);
    return () => clearTimeout(debounceRef.current);
  }, [query, active]);

  return suggestions;
}

function PlaceSuggestInput({ value, onChangeText, onSelect, placeholder, style }) {
  const [focused, setFocused] = React.useState(false);
  const suggestions = usePlaceSuggestions(value, focused);
  return (
    <div style={{ position: "relative" }}>
      <input
        value={value}
        onChange={(e) => onChangeText(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setTimeout(() => setFocused(false), 150)}
        placeholder={placeholder}
        style={style}
      />
      {focused && suggestions.length > 0 && (
        <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, zIndex: 30, background: "var(--color-surface)", border: "1px solid var(--color-border)", borderRadius: 9, overflow: "hidden", boxShadow: "var(--shadow-card)" }}>
          {suggestions.map((s, i) => (
            <button
              key={i}
              onMouseDown={(e) => { e.preventDefault(); onSelect(s); }}
              style={{
                display: "block", width: "100%", textAlign: "left", padding: "8px 10px", cursor: "pointer",
                background: "transparent", border: "none",
                borderBottom: i < suggestions.length - 1 ? "1px solid var(--color-border)" : "none",
                fontFamily: "var(--font-body)",
              }}
            >
              <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-primary)" }}>{s.name}</div>
              {s.detail && <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)" }}>{s.detail}</div>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
window.PlaceSuggestInput = PlaceSuggestInput;
